import axios from 'axios';
import { observer } from "mobx-react";
import { getProductsData } from '@/utils/woocommerce';
import { getFrontpage } from '@/utils/endpoints';
import HomePage from '@/components/page-templates/HomePage';

const Home = observer(({
  pageData,
  featuredProductsList,
  sliderProductsList,
  crossSellProducts,
}) => {
  return (
    <>
      <HomePage pageData={pageData} featuredProductsList={featuredProductsList} sliderProductsList={sliderProductsList} crossSellProducts={crossSellProducts} />
    </>
  );
});

export default Home;

export async function getStaticProps() {
  const { data } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/settings`);
  const { data: studioData } = await axios.get(`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/acf_studio`);
  const pageData = await getFrontpage();

  let lang = 'en';

  if (data?.language) {
    lang = data.language.split('_')[0];
  }

  const messages = await import(`../messages/${lang}.json`);

  // Initialize products arrays for different sections
  const featuredProductsList = [];
  const sliderProductsList = [];
  let crossSellProducts = [];

  // Check if sections exist and fetch products accordingly
  if (pageData?.acf?.sections) {
    for (const section of pageData.acf.sections) {
      if (section.acf_fc_layout === 'Featured_Products') {
        const settings = section.products_source;
        const { data: fetchedProducts, crossSellProducts: fetchedCrossSellProducts } = await getProductsData(
          settings?.per_page,
          'publish',
          settings?.featured,
          false,
          settings?.category,
          1,
          settings?.include,
          settings?.order_by,
          settings?.order,
        );
        featuredProductsList.push(fetchedProducts || {});
        crossSellProducts = [...crossSellProducts, ...(fetchedCrossSellProducts || [])];
      }

      if (section.acf_fc_layout === 'Products_Slider') {
        const settings = section.products_source;
        const { data: fetchedProducts, crossSellProducts: fetchedCrossSellProducts } = await getProductsData(
          settings?.per_page,
          'publish',
          settings?.featured,
          false,
          settings?.category,
          1,
          settings?.include,
          settings?.order_by,
          settings?.order,
        );
        sliderProductsList.push(fetchedProducts || {});
        crossSellProducts = [...crossSellProducts, ...(fetchedCrossSellProducts || [])];
      }
    }
  }

  return {
    props: {
      data: data || {},
      studioData: studioData || {},
      messages: messages.default,
      pageData: pageData ?? {},
      featuredProductsList,
      sliderProductsList,
      crossSellProducts,
    },
    revalidate: 300,
  };
}
